import { AxiosResponse } from 'axios';

// login was successful is we are redirected to the previous conx-ui location
const validateLoginResponse = (response: AxiosResponse): boolean => {
  // responseURL - final URL obtained after any redirects
  return (response.request.responseURL.includes('frontend/site'));
};

const loginService = { validateLoginResponse };

export default loginService;